import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/auth/sign-in`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const signIn = {
  post: apiPathFunc(pathBase),
};
